(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["subscription-notice"] && !Shopify.designMode) return;
  try {
    (() => {
    const planIsSelected = () => {
      const widget = document.querySelector('fh-selling-plans-widget');
      if (!widget) return false;

      if (widget.querySelector('input[data-radio-type="selling_plan"]:checked')) {
        return true;
      }

      const hiddenInput = widget.querySelector('input.selected-selling-plan-id');
      return Boolean(hiddenInput && hiddenInput.value);
    };

    const syncNotices = () => {
      const selected = planIsSelected();
      const widget = document.querySelector('fh-selling-plans-widget');

      if (widget) {
        widget.classList.toggle('subscription-notice-active', selected);
      }

      for (const notice of document.querySelectorAll('[data-subscription-notice]')) {
        notice.hidden = !selected;
      }
    };

    const bindWidget = (widget) => {
      if (widget.dataset.noticeBound === 'true') return;

      widget.dataset.noticeBound = 'true';
      widget.addEventListener('change', syncNotices);

      const observer = new MutationObserver(syncNotices);
      observer.observe(widget, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['checked', 'value'],
      });
    };

    const init = () => {
      const widget = document.querySelector('fh-selling-plans-widget');
      if (widget) bindWidget(widget);
      syncNotices();
    };

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (!target.closest('fh-selling-plans-widget')) return;
      syncNotices();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    const deadline = Date.now() + 5000;
    const waitForWidget = () => {
      init();
      if (Date.now() > deadline) return;
      requestAnimationFrame(waitForWidget);
    };

    requestAnimationFrame(waitForWidget);
  })();
  } catch(e) { console.error(e); }
})();

})();
